import { app } from './zapatos';

// Ref: https://docs.atomicvest.com/docs/cancelling-transactions-1
export const CANCELABLE_USER_TXN_STATUSES: app.transaction_status[] = [
    'PLANNED',
    'REQUESTED',
    'SCHEDULED',
    'EXTERNAL_ACCOUNT_DISCONNECTED',
    'EXTERNAL_ACCOUNT_MISSING',
    'EXTERNAL_ACCOUNT_BALANCE_UPDATE_REQUIRED',
    'EXTERNAL_ACCOUNT_INSUFFICIENT_BALANCE',
];
export const CANCELABLE_ADMIN_TXN_STATUSES: app.transaction_status[] = [
    ...CANCELABLE_USER_TXN_STATUSES,
    'QUEUED',
    'REQUESTING',
    'TRANSFER_PLANNED',
    'TRANSFER_QUEUED',
    'TRANSFER_REQUESTING',
    'TRANSFER_REQUESTED',
];

// The following type annotation ensures that the array matches the
// app.terminal_transaction_status enum in the DB.
export const terminalAppTransactionStatuses: app.every.terminal_transaction_status =
    ['CANCELED', 'COMPLETED', 'EXPIRED', 'FAILED'];

export const isTerminalAppTransactionStatus = (
    status: app.transaction_status
) => {
    return (terminalAppTransactionStatuses as string[]).includes(status);
};
